import { createStyles, getStylesRef } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    marginTop: 50,
    backgroundColor: "#fff",
    padding: "1rem",
    borderRadius: "10px",
  },
  rightBTN: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    borderRadius: "16px",
    background: "#FFF",
    padding: "12px 8px",
    gap: 12,
    marginBlock: 30,
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "#FFBA45",
    borderRadius: 5,
    cursor: "pointer",
  },
  FilterIcon: {
    // background: "#FFBA45",
    padding: "5px",
    borderRadius: 3,
    cursor: "pointer",
  },
  titleText: {
    color: "#171717",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px", // 150%
  },
  filterMenu: {
    padding: "0 !important",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
  },
  notesFilterBox: {
    borderRadius: "16px",
    "& .header": {
      padding: "13px 19px",
      borderRadius: "16px 16px 0px 0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#FFF",
      "& .mantine-Text-root": {
        color: "#000",
        fontFamily: "Inter",
        fontSize: "24px",
        fontWeight: "700",
      },
      "& button": {
        padding: "0px",
      },
    },
    "& .filterBody": {
      backgroundColor: "#F5F5F5",
      padding: "12px 12px 30px 12px",
      display: "flex",
      flexDirection: "column",
      gap: 7,
      "& .fieldParent": {
        padding: "12px",
        borderRadius: "8px",
        border: "1px solid #E5E5EA",
        background: "#FFF",
        "& .datePicker": {
          fontFamily: "Inter",
          "& .mantine-InputWrapper-label": {
            color: "#344054",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 500,
          },
          "& .mantine-Input-wrapper": {
            marginTop: "8px",
            backgroundColor: "#FFF",
            borderRadius: "8px",
            border: "1px solid #D4D4D4",
            boxShadow:
              "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",

            "& .mantine-DatePickerInput-input": {
              paddingBlock: "10px",
              height: "auto",
              color: "#262626",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 600,
            },
          },
        },
      },
    },
    "& .boxFooter": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "18px 15px",
      borderTop: "1px solid #E5E5E5",
      borderRadius: "0px 0px 16px 16px",
      background: "#FFF",
      "& button": {
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        borderRadius: "8px",
        padding: "8px 14px",
        height: "auto",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        fontFamily: "Inter",
      },
      "& .resetBtn": {
        backgroundColor: "#F9FAFB",
        border: "1px solid #D0D5DD",
        color: "#1D2939",
      },
      "& .applyBtn": {
        backgroundColor: "#262626",
        border: "1px solid #262626",
        color: "#FFF",
      },
    },
  },
  searchInput: {
    width: "55%",
    height: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& .mantine-Input-input": {
      fontFamily: "Inter",
      border: "none",
      backgroundColor: "transparent",
      height: "44px",
      fontFamily: "Inter",
    },
  },
  box_header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px"
  }, 
  box_body: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    background: "#F5F5F5",
    padding: "15px",
    borderTop: "1px solid #E5E5EA",
    borderBottom: "1px solid #E5E5EA",
    // "& .filterFields": {
    //   padding: "12px"
    // }
  },
  filterFields: {
    padding: "12px",
    background: "#FFFFFF",
    border: "1px solid #E5E5EA",
    borderRadius: "8px"
  },
  btn_container: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px"
  },
  search_container: {
    backgroundColor: "#fff",
    padding: "1rem",
  },
  filterCategoryList: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  filterCategoryItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 15px",
    cursor: "pointer",
    borderBottom: "1px solid #F0F0F0",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "#344054",
    "&:hover": {
      backgroundColor: "#F9FAFB",
    },
  },
  activeFilterDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#FFAF4A",
  },
  filterCategoryHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 15px",
    borderBottom: "1px solid #E5E5EA",
    cursor: "pointer",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "#344054",
  },
  activeFiltersBar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    backgroundColor: "#fff",
    padding: "8px 2rem",
  },
  filterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: "16px",
    backgroundColor: "#F2F4F7",
    border: "1px solid #E5E5EA",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "#344054",
    "& svg": {
      cursor: "pointer",
      color: "#667085",
      "&:hover": {
        color: "#344054",
      },
    },
  },
  clearAllLink: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "#FFAF4A",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;
